<template>
  <!-- 登录弹窗：核心修复 - 仅保留v-model控制显隐，移除v-if避免DOM销毁时序问题 -->
  <el-dialog
    title="用户登录"
    v-model="isDialogOpen"
    width="1088px"
    top="3vh"
    :close-on-click-modal="false"
    :show-close="true"
    @close="handleDialogClose"
  >
    <div class="login-container">
      <div class="login-top-tabs">
        <h6 @click="tabb('wx')" :class="{ actives: activess == 'wx' }">
          微信登录
        </h6>
        <h6 @click="tabb('dy')" :class="{ actives: activess == 'dy' }">
          抖音登录
        </h6>
        <h6 @click="tabb('zfb')" :class="{ actives: activess == 'zfb' }">
          支付宝登录
        </h6>
        <h6 @click="tabb('phone')" :class="{ actives: activess == 'phone' }">
          手机快捷登录
        </h6>
      </div>

      <div
        class="scan-login"
        v-if="loginType === 'scan'"
        :class="{ active: loginType === 'scan' }"
      >
        <div class="scan-content">
          <div class="qrcode-box" v-if="box == 'dy'">
            <!-- 抖音iframe登录容器 -->
            <div v-if="douyinIframeUrl" class="douyin-iframe-container">
              <iframe
                :src="douyinIframeUrl"
                width="400"
                height="260"
                frameborder="0"
                allowtransparency="true"
                scrolling="no"
                title="抖音扫码登录"
              ></iframe>
            </div>
            <!-- 加载中状态 -->
            <div v-else class="loading-state">
              <i class="el-icon-loading" style="font-size: 20px"></i>
              <p>正在加载登录二维码...</p>
            </div>
            <p>请使用抖音扫码登录</p>
          </div>
          <div class="qrcode-box" v-else-if="box === 'wx'">
            <!-- 微信iframe登录容器 -->
            <div v-if="wxIframeUrl" class="douyin-iframe-container">
              <iframe
                style="margin: 0 -30px"
                :src="wxIframeUrl"
                width="400"
                height="260"
                frameborder="0"
                allowtransparency="true"
                scrolling="no"
                title="微信扫码登录"
                sandbox="allow-scripts allow-same-origin allow-popups"
                allow="fullscreen"
              ></iframe>
            </div>

            <div v-else class="loading-state">
              <i class="el-icon-loading" style="font-size: 20px"></i>
              <p>正在加载登录二维码...</p>
            </div>
            <p>请使用微信扫码登录</p>
          </div>
          <div class="qrcode-box" v-else-if="box === 'zfb'">
            <div v-if="douyinIframeUrl" class="douyin-iframe-container">
              <div>123</div>
            </div>
            <!-- 加载中状态 -->
            <div v-else class="loading-state">
              <i class="el-icon-loading" style="font-size: 20px"></i>
              <p>正在加载登录二维码...</p>
            </div>
            <p>请使用支付宝扫码登录</p>
          </div>
          <div class="qrcode-box" v-else>
            <div>404,出错了此页面为空白</div>
          </div>
          <div class="scan-tips">
            <p>扫码前请确保对应平台已绑定您的账号</p>
            <p>
              未绑定？<a href="javascript:;" @click="switchLoginType('phone')"
                >使用手机号快捷登录</a
              >
            </p>
          </div>
        </div>
      </div>

      <!-- 手机号验证码登录（自动注册） -->
      <div
        class="phone-login"
        v-if="loginType === 'phone'"
        :class="{ active: loginType === 'phone' }"
      >
        <div class="login-header">
          <h3>手机号快捷登录</h3>
          <div class="divider" :class="{ active: loginType === 'phone' }"></div>
          <p class="login-desc" v-if="loginMode !== 'subAccount'">
            未注册用户将自动完成注册
          </p>
        </div>

        <div class="login-form-wrapper">
          <el-form
            :model="loginForm"
            :rules="loginRules"
            ref="loginFormRef"
            label-width="80px"
            class="login-form"
          >
            <!-- =========修改：增加子账号登录，横向三个选项 ========= -->
            <div class="login-mode-switch">
              <span
                @click="setLoginMode('password')"
                :class="{ active: loginMode === 'password' }"
              >
                密码登录
              </span>
              <span
                @click="setLoginMode('code')"
                :class="{ active: loginMode === 'code' }"
              >
                验证码登录
              </span>
              <span
                @click="setLoginMode('subAccount')"
                :class="{ active: loginMode === 'subAccount' }"
              >
                子账号登录
              </span>
            </div>

            <el-form-item label="账号" prop="phone">
              <el-input
                v-model="loginForm.phone"
                :placeholder="
                  loginMode === 'subAccount' ? '请输入子账号' : '请输入手机号'
                "
                prefix-icon="el-icon-phone"
                maxlength="11"
              ></el-input>
            </el-form-item>

            <!-- 动态显示密码或验证码输入框 -->
            <el-form-item
              :label="
                loginMode === 'password'
                  ? '登录密码'
                  : loginMode === 'code'
                  ? '验证码'
                  : '登录密码'
              "
              :prop="
                loginMode === 'password'
                  ? 'password'
                  : loginMode === 'code'
                  ? 'code'
                  : 'password'
              "
            >
              <div class="code-input" v-if="loginMode === 'code'">
                <el-input
                  v-model="codes"
                  placeholder="请输入6位验证码"
                  prefix-icon="el-icon-message"
                  maxlength="6"
                ></el-input>
                <el-button
                  type="text"
                  :style="{ color: '#C1272D' }"
                  @click="sendCode"
                  :disabled="codeDisabled"
                >
                  {{ codeText }}
                </el-button>
              </div>

              <el-input
                v-else
                v-model="loginForm.password"
                type="password"
                placeholder="请输入登录密码"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <!-- 密码 / 子账号模式下显示图形验证码 -->
            <el-form-item
              label="验证码"
              prop="captcha"
              v-if="loginMode === 'password' || loginMode === 'subAccount'"
            >
              <div class="captcha-input-wrapper">
                <el-input
                  v-model="code"
                  placeholder="请输入验证码"
                  maxlength="4"
                  style="width: 49%"
                ></el-input>
                <!-- 验证码图片 + 刷新按钮 -->
                <div class="captcha-img-wrapper">
                  <img
                    :src="captchaBase"
                    alt="验证码"
                    class="captcha-img"
                    @click="refreshCaptcha"
                    title="点击刷新验证码"
                  />
                </div>
              </div>
            </el-form-item>

            <!-- =========关键：子账号登录隐藏用户身份 ========= -->
            <el-form-item
              label="用户身份"
              prop="identity"
              v-if="loginMode !== 'subAccount'"
            >
              <el-select
                v-model="loginForm.identity"
                placeholder="请选择您的身份"
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label=" " class="agreement">
              <el-checkbox v-model="loginAgreement">
                <span
                  >我同意《<a href="javascript:;">用户协议</a>》《<a
                    href="javascript:;"
                    >隐私条款</a
                  >》</span
                ></el-checkbox
              >
            </el-form-item>

            <el-form-item label=" ">
              <el-button
                type="primary"
                :style="{
                  backgroundColor: '#C1272D',
                  borderColor: '#C1272D',
                  width: '100%',
                }"
                @click="handleLogin"
                :disabled="!loginAgreement"
              >
                {{ loginMode === "code" ? "登录/注册" : "登录" }}
              </el-button>
            </el-form-item>

            <!-- 子账号隐藏底部忘记密码提示 -->
            <div class="form-footer" v-if="loginMode !== 'subAccount'">
              <a href="javascript:;" v-if="loginMode === 'password'">
                忘记密码？<span
                  @click="setLoginMode('code')"
                  style="color: #c1272d; cursor: pointer"
                  >使用验证码登录</span
                >
              </a>
              <p class="tip-text" v-if="loginMode === 'code'">
                验证码登录即表示同意自动注册账号
              </p>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "LoginDialog",
  // 接收父组件传递的参数
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    basicAuth: {
      type: Object,
      required: true,
      default: () => ({
        clientId: "",
        clientSecret: "",
      }),
    },
  },

  computed: {
    isDialogOpen: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    // 动态表单校验规则
    loginRules() {
      const baseRules = {
        password: [
          // { required: true, message: "请输入登录密码", trigger: "blur" },
          { min: 6, max: 18, message: "密码长度为6-18位", trigger: "blur" },
        ],
      };
      // 子账号模式不需要校验身份
      if (this.loginMode !== "subAccount") {
        baseRules.identity = [
          { required: true, message: "请选择用户身份", trigger: "change" },
        ];
      }
      return baseRules;
    },
  },
  data() {
    return {
      code: "", // 图形验证码输入框
      codeid: "", // 图形验证码ID
      captchaBase: "", // 图形验证码图片
      // 用户身份选项
      options: [
        { id: 1, name: "服装商" },
        { id: 2, name: "服装设计师" },
        { id: 3, name: "面料商" },
        { id: 4, name: "面料采购" },
        { id: 5, name: "纺服相关" },
        { id: 6, name: "其他" },
      ],
      box: "",
      wxIframeUrl: "", // 微信iframe登录页URL（与抖音格式一致）
      zfbAuthUrl: "",
      qrCodeInstances: null,
      // 登录相关状态
      loginType: "scan",
      loginMode: "code", // password / code / subAccount
      douyinIframeUrl: "", // 抖音iframe登录页URL
      // 轮询相关（微信与抖音共用，完全一致）
      loginPollingTimer: null,
      pollingInterval: 2000,
      currentState: "", // 共用state（抖音/微信）
      activess: "",
      codes: "", // 短信验证码
      // 登录表单数据
      loginForm: {
        phone: "",
        password: "",
        identity: "",
      },
      // 协议勾选
      loginAgreement: false,
      // 短信验证码相关
      codeText: "获取验证码",
      codeDisabled: false,
      codeCountdown: 60,
      countdownTimer: null,
      // 组件存活状态标记
      isAlive: true,
    };
  },
  mounted() {
    // 弹窗打开时初始化登录（与抖音逻辑一致）
    if (this.isDialogOpen) {
      this.initLogin();
    }
  },
  beforeUnmount() {
    // 清理所有资源（微信与抖音共用）
    this.isAlive = false;
    this.clearCountdownTimer();
    this.clearLoginPolling();
    this.douyinIframeUrl = "";
    this.wxIframeUrl = "";
  },
  watch: {
    // 监听弹窗显隐，初始化/清理资源（与抖音逻辑一致）
    modelValue(newVal) {
      if (newVal) {
        this.isAlive = true;
        this.initLogin();
      } else {
        this.handleDialogClose();
      }
    },
    // 监听登录模式切换，密码/子账号模式加载图形验证码
    loginMode(newMode) {
      if (
        (newMode === "password" || newMode === "subAccount") &&
        this.isAlive
      ) {
        this.getCaptcha();
      }
    },
  },
  methods: {
    // ===== 图形验证码相关 =====
    async getCaptcha() {
      try {
        this.code = "";
        const res = await this.$api.Login.LoGIn.yzm();
        this.codeid = res.data.data?.captchaId || res.data.captchaId;
        this.captchaBase =
          res.data.data?.captchaBase64 || res.data.captchaBase64;
        if (!this.captchaBase) throw new Error("验证码数据为空");
      } catch (error) {
        this.$message.error("验证码获取失败，请刷新重试");
        console.error("验证码异常：", error);
        setTimeout(() => this.getCaptcha(), 3000);
      }
    },
    refreshCaptcha() {
      this.getCaptcha();
    },
    // ===== 初始化与清理相关 =====
    initLogin() {
      this.loginType = "scan";
      this.loginMode = "code";
      this.loginAgreement = false;
      this.douyinIframeUrl = "";
      this.wxIframeUrl = "";
      this.clearCountdownTimer();
      // 重置表单
      this.$nextTick(() => {
        if (this.isAlive && this.$refs.loginFormRef) {
          try {
            this.$refs.loginFormRef.resetFields();
          } catch (e) {
            console.debug("表单重置失败：组件未初始化", e);
          }
        }
      });
      this.tabb("wx");
    },
    getBasicAuthHeader() {
      const { clientId, clientSecret } = this.basicAuth;
      const authStr = `${clientId}:${clientSecret}`;
      const base64Auth = btoa(unescape(encodeURIComponent(authStr)));
      return `Basic ${base64Auth}`;
    },
    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        this.codeText = "获取验证码";
        this.codeDisabled = false;
        this.codeCountdown = 60;
      }
    },
    clearLoginPolling() {
      if (this.loginPollingTimer) {
        clearInterval(this.loginPollingTimer);
        this.loginPollingTimer = null;
      }
    },
    // ===== 平台切换（抖音/微信/支付宝/手机登录）=====
    async tabb(act) {
      if (act === "dy") {
        this.box = "dy";
        this.activess = act;
        this.loginType = "scan";
        try {
          const res = await this.$api.Login.LoGIn.logins();
          if (res.data.code === "200" && res.data.data) {
            this.douyinIframeUrl = res.data.data;
            this.currentState = this.extractStateFromUrl(res.data.data);
            this.clearLoginPolling();
            this.loginPollingTimer = setInterval(() => {
              this.getTokenByState();
            }, this.pollingInterval);
          } else {
            this.$message.error("获取抖音登录页面失败，请重试");
          }
        } catch (error) {
          console.error("调用抖音授权接口失败：", error);
          this.$message.error("网络异常，无法获取登录链接");
        }
      } else if (act === "wx") {
        this.activess = act;
        this.box = "wx";
        this.loginType = "scan";
        this.clearLoginPolling();
        this.wxIframeUrl = "";

        try {
          const res = await this.$api.Login.LoGIn.wxlogin();
          if (res.data.code === "200" && res.data.data) {
            const wxBaseUrl = res.data.data;
            this.wxIframeUrl = `${wxBaseUrl}${
              wxBaseUrl.includes("?") ? "&" : "?"
            }self_redirect=true`;
            this.currentState = this.extractStateFromUrl(this.wxIframeUrl);
            this.loginPollingTimer = setInterval(() => {
              this.getTokenByState();
            }, this.pollingInterval);
            this.$message.success("获取微信登录页面成功！");
          } else {
            this.$message.error("获取微信登录页面失败，请重试");
          }
        } catch (error) {
          console.error("调用微信授权接口失败：", error);
          this.$message.error("网络异常，无法获取登录链接");
        }
      } else if (act === "zfb") {
        this.box = "zfb";
        this.activess = act;
        this.loginType = "scan";
        this.clearLoginPolling();
      } else if (act === "phone") {
        this.loginForm.identity = localStorage.getItem("yhname") || "";
        this.activess = "phone";
        this.loginType = "phone";
        this.loginMode = "password";
        this.clearLoginPolling();
      }
    },
    extractStateFromUrl(url) {
      const stateMatch = url.match(/state=([^&]+)/);
      return stateMatch ? stateMatch[1] : "";
    },
    async getTokenByState() {
      if (!this.isAlive || !this.currentState) {
        this.clearLoginPolling();
        return;
      }
      try {
        let res;
        if (this.activess === "dy") {
          res = await this.$api.Login.LoGIn.getoken(this.currentState, {
            headers: {
              Authorization: this.getBasicAuthHeader(),
            },
          });
        } else if (this.activess === "wx") {
          res = await this.$api.Login.LoGIn.getoken(this.currentState, {
            headers: {
              Authorization: this.getBasicAuthHeader(),
            },
          });
        } else {
          this.clearLoginPolling();
          return;
        }
        if (res.data.code === "200" && res.data.data) {
          const token = res.data.data;
          this.$emit("login-success", {
            type: this.activess,
            token,
          });
          this.isDialogOpen = false;
          this.$message.success(
            `${this.activess === "dy" ? "抖音" : "微信"}扫码登录成功！`
          );
          this.clearLoginPolling();
        }
      } catch (error) {
        console.debug(
          `暂未获取到${
            this.activess === "dy" ? "抖音" : "微信"
          }token，继续轮询...`,
          error
        );
      }
    },
    switchLoginType(type) {
      if (!this.isAlive) return;
      this.loginType = type;
      if (type === "phone") {
        this.clearLoginPolling();
        if (this.loginMode === "password" || this.loginMode === "subAccount") {
          this.getCaptcha();
        }
      }
    },
    // 模式切换：密码 / 验证码 / 子账号
    setLoginMode(mode) {
      if (!this.isAlive) return;
      this.loginMode = mode;
      // 切换清理
      this.loginForm.password = "";
      this.codes = "";
      this.code = "";
      this.captchaBase = "";
      // 密码/子账号加载验证码
      if (mode === "password" || mode === "subAccount") {
        this.getCaptcha();
      }
    },
    sendCode() {
      if (!this.isAlive) return;
      if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      this.clearCountdownTimer();
      this.codeDisabled = true;
      this.codeText = `${this.codeCountdown}s后重新获取`;
      this.countdownTimer = setInterval(() => {
        if (!this.isAlive) {
          this.clearCountdownTimer();
          return;
        }
        this.codeCountdown--;
        this.codeText = `${this.codeCountdown}s后重新获取`;
        if (this.codeCountdown <= 0) {
          this.clearCountdownTimer();
        }
      }, 1000);
      setTimeout(() => {
        if (this.isAlive) {
          this.$message.success("验证码已发送，请注意查收");
        }
      }, 500);
    },
    async handleLogin() {
      if (!this.isAlive || !this.$refs.loginFormRef) return;
      this.$refs.loginFormRef.validate((isValid) => {
        if (!this.isAlive) return;
        if (isValid && this.loginAgreement) {
          setTimeout(async () => {
            if (!this.isAlive) return;
            const loginFormData = new FormData();
            loginFormData.append("username", this.loginForm.phone);
            if (this.loginForm.password) {
              loginFormData.append("password", this.loginForm.password);
            }
            if (
              (this.loginMode === "password" ||
                this.loginMode === "subAccount") &&
              this.codeid
            ) {
              loginFormData.append("captchaId", this.codeid);
            }
            if (
              (this.loginMode === "password" ||
                this.loginMode === "subAccount") &&
              this.code
            ) {
              loginFormData.append("captchaCode", this.code);
            }
            if (this.loginMode === "code" && this.codes) {
              loginFormData.append("smsCode", this.codes);
            }
            // 子账号不携带identity
            if (this.loginForm.identity && this.loginMode !== "subAccount") {
              loginFormData.append(
                "identity",
                this.options.filter(
                  (item) => item.name == this.loginForm.identity
                )[0].id
              );
            }
            const grantType =
              this.loginMode === "code" ? "password" : "captcha";
            loginFormData.append("grant_type", grantType);

            try {
              const res = await this.$api.Login.LoGIn.pass(loginFormData, {
                headers: {
                  Authorization: this.getBasicAuthHeader(),
                },
              });

              if (res.data.code === "200") {
                // 子账号不保存身份
                if (this.loginMode !== "subAccount") {
                  localStorage.setItem("yhname", this.loginForm.identity);
                }
                const mockToken = res.data.data.access_token;
                this.$emit("login-success", {
                  type: this.activess,
                  token: mockToken,
                  loginMode: this.loginMode,
                });
                this.isDialogOpen = false;
                this.$message.success("登录成功");
              } else {
                this.getCaptcha();
                this.$message.error(res.data.msg);
              }
            } catch (error) {
              console.error("调用登录接口失败：", error);
              this.$message.error("网络异常");
            }
          }, 800);
        } else if (!this.loginAgreement) {
          this.$message.warning("请勾选用户协议和隐私条款");
        }
      });
    },
    handleDialogClose() {
      this.isAlive = false;
      this.clearCountdownTimer();
      this.clearLoginPolling();
      this.douyinIframeUrl = "";
      this.wxIframeUrl = "";

      if (this.$refs.loginFormRef) {
        try {
          this.$refs.loginFormRef.resetFields();
        } catch (e) {
          console.debug("表单重置失败：组件已销毁", e);
        }
      }
      this.loginForm = { phone: "", code: "", password: "", identity: "" };
      this.code = "";
      this.captchaBase = "";
      this.codeid = "";
      this.loginAgreement = false;
      this.$emit("dialog-close");
    },
  },
};
</script>

<style scoped lang="less">
@import "./LoginDialog.scss";
</style>